import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import React from "react";
import { useUsePlanningMapProjectDataQuery } from "./usePlanningMapProjectData.generated.js";

// export const usePlanningMapProjectData = () => {
//   const client = useApolloClient();
//   const [fetch, query] = useUsePlanningMapProjectDataLazyQuery({
//     client,
//   });
//
//   const fetchPlanningMapProjectData = React.useCallback(
//     async (projectIds: string[]) => {
//       const r = await fetch({
//         variables: { projectIds, limit: projectIds.length },
//       });
//       return getDataOrNull(r.data?.projects)?.edges.map(e => e.node) ?? [];
//     },
//     [fetch]
//   );
//
//   return fetchPlanningMapProjectData;
// };

export const usePlanningMapProjectData = (projectIds: string[]) => {
  const client = useApolloClient();
  const query = useUsePlanningMapProjectDataQuery({
    client,
    variables: { projectIds, limit: projectIds.length },
    skip: !projectIds.length,
  });
  return React.useMemo(
    () =>
      !projectIds.length
        ? []
        : (getDataOrNull(query.data?.projects)?.edges.map(e => e.node) ?? []),
    [projectIds.length, query.data?.projects]
  );
};
